import React from 'react'
import PropTypes from 'prop-types'
import { FilterPills as BoltFilterPills } from '@sainsburys-tech/bolt'

import * as Styled from './styles'

const FilterPills = ({ filters, onActivate, onDeactivate, pillFilterType }) => {
  const pillFilter = filters.find(filter => filter.id === pillFilterType)

  if (!pillFilter) {
    return null
  }

  const pills = pillFilter?.values?.map(filter => ({
    label: `${filter.label} (${filter.value})`,
    active: filter.applied,
    id: filter.id
  }))

  return (
    <>
      <Styled.Heading>Filter by {pillFilterType}</Styled.Heading>
      <Styled.Wrapper>
        <BoltFilterPills
          pills={pills}
          onActivate={onActivate}
          onDeactivate={onDeactivate}
          isAnimated={false}
          data-test={`filter-pills-${pillFilterType}`}
        />
      </Styled.Wrapper>
    </>
  )
}

FilterPills.propTypes = {
  filters: PropTypes.array,
  onActivate: PropTypes.func,
  onDeactivate: PropTypes.func,
  pillFilterType: PropTypes.string
}

FilterPills.defaultProps = {
  filters: [],
  onActivate: () => {},
  onDeactivate: () => {},
  pillFilterType: ''
}

export default FilterPills
